import { render, staticRenderFns } from "./TableSchemaEditor.vue?vue&type=template&id=80b6980a"
import script from "./TableSchemaEditor.vue?vue&type=script&lang=js"
export * from "./TableSchemaEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports